import { render, staticRenderFns } from "./StackItem.vue?vue&type=template&id=360a38ae&scoped=true&lang=pug&"
import script from "./StackItem.vue?vue&type=script&lang=js&"
export * from "./StackItem.vue?vue&type=script&lang=js&"
import style0 from "./StackItem.vue?vue&type=style&index=0&id=360a38ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360a38ae",
  null
  
)

export default component.exports